export const LOCALSTORAGE_TOKEN = 'startupvn-token';
export const LOCALSTORAGE_TOKEN_KEY = 'starupvn-token-key';
